import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { Button } from '../components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchWishlist = useCallback(async () => {
    try {
      const { data: wishlistData } = await axios.get(`${BACKEND_URL}/api/wishlist`, { withCredentials: true });
      setWishlistItems(wishlistData.items || []);
      
      if (wishlistData.items && wishlistData.items.length > 0) {
        const { data: productsData } = await axios.get(`${BACKEND_URL}/api/products`);
        const filteredProducts = productsData.filter(p => wishlistData.items.includes(p.id));
        setProducts(filteredProducts);
      } else {
        setProducts([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch wishlist:', error);
      setLoading(false);
    }
  }, []);

  const handleWishlistToggle = useCallback((productId, isNowInWishlist) => {
    if (isNowInWishlist) {
      fetchWishlist();
      return;
    }

    setWishlistItems((currentItems) => currentItems.filter((id) => id !== productId));
    setProducts((currentProducts) => currentProducts.filter((product) => product.id !== productId));
  }, [fetchWishlist]);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  if (loading) {
    return (
      <div className="heritage-page min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#c79a35]"></div>
      </div>
    );
  }

  return (
    <div className="heritage-page min-h-screen flex flex-col">
      <Header />
      
      <main className="heritage-shell flex-1">
        <h1 className="heritage-title mb-8 text-5xl" data-testid="wishlist-title">My Wishlist</h1>

        {products.length === 0 ? (
          <div className="text-center py-12" data-testid="empty-wishlist">
            <p className="text-[#6a5448] text-lg mb-4">Your wishlist is empty</p>
            <Button onClick={() => navigate('/products')} className="heritage-button rounded-none" data-testid="browse-products-btn">
              Browse Products
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="wishlist-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                inWishlist={true}
                onWishlistToggle={handleWishlistToggle}
              />
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Wishlist;
